import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PersonalInformation } from '../../../../../interfaces/PersonalInformation';
import { StyledLine } from './Email.styles';

export interface EmailProps {
  personalInfo: PersonalInformation;
}
const Email: FC<EmailProps> = ({ personalInfo }) => {
  const { t } = useTranslation('PersonalInformationsTile');
  return (
    <>
      {personalInfo?.emails.home && personalInfo?.emails.home !== '' ?
        <StyledLine>
          <span>{t('emails.homeEmailLabel')}</span>
          {personalInfo?.emails.home}
        </StyledLine> : null}
      {personalInfo?.emails.work && personalInfo?.emails.work !== '' ?
        <StyledLine>
          <span>{t('emails.workEmailLabel')}</span>
          {personalInfo?.emails.work}
        </StyledLine> : null}
    </>
  );
};
export default Email;
